<template>
  <div class="container-form margin-top-30">
    <h4 class="section-name-form">Datele bancare</h4>
    <p
      class="section-description-form"
    >Datele bancare vor fi folosite atât în contract, cât și pentru a identifica plățile în platforma noastră</p>
    <div class="row">
      <div class="col-md-8 margin-top-15">
        <form-input
          input-type="text"
          input-name="iban"
          :input-label="ibanLabel"
          :input-value="iban"
          :setInput="setIban"
          :is-valid="validIban"
          :disabled="false"
          :error-text="ibanInvalid"
        ></form-input>
      </div>
      <div class="col-md-4 margin-top-15">
        <form-input
          input-type="text"
          input-name="bank"
          :input-label="bankLabel"
          :input-value="bank"
          :setInput="setBank"
          :is-valid="validBank"
          :disabled="false"
          :error-text="bankInvalid"
        ></form-input>
      </div>
    </div>
    <div class="align-button-form margin-top-30">
      <button-form button-name="PASUL URMĂTOR" :on-click="nextStep"></button-form>
    </div>
  </div>
</template>

<script>
import FormInput from "../global/FormInput";
import ButtonForm from "../global/ButtonForm";
import { IBAN_LABEL, BANK_LABEL } from "../../content/FormLabels";
import { GENERAL_INVALID } from "../../content/FormErrors";
import { mapState, mapMutations } from "vuex";
import { notNull, validateIban } from "../../helpers/Validations";

export default {
  components: {
    FormInput,
    ButtonForm
  },
  data() {
    return {
      ibanLabel: IBAN_LABEL,
      bankLabel: BANK_LABEL,
      ibanInvalid: GENERAL_INVALID,
      bankInvalid: GENERAL_INVALID
    };
  },
  computed: {
    ...mapState({
      iban: state => state.formInputs.iban,
      bank: state => state.formInputs.bank,
      validIban: state => state.isFormValid.iban,
      validBank: state => state.isFormValid.bank
    })
  },
  methods: {
    ...mapMutations([
      "addIban",
      "addBank",
      "isIbanValid",
      "isBankValid",
      "incrementWizardStep"
    ]),
    setIban: function(event) {
      if (this.iban !== event.target.value.trim())
        this.addIban(event.target.value.trim());
    },
    setBank: function(event) {
      if (this.bank !== event.target.value.trim())
        this.addBank(event.target.value.trim());
    },
    nextStep: function() {
      const isIbanValid = validateIban(this.iban);
      this.isIbanValid(isIbanValid);

      const isBankValid = notNull(this.bank);
      this.isBankValid(isBankValid);

      if (isIbanValid && isBankValid) {
        this.incrementWizardStep();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  font-size: 1rem;
}
</style>

